import {Box, Divider, IconButton, Typography} from "@mui/material";
import {Fragment, useEffect, useState} from "react";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import {Close, Delete} from "@mui/icons-material";
import {TimeManager} from "../../timemanager";
import useToken from "../../useToken";

export default function PeriodPresets(props) {
    const {
        open,
        labels,
        draggingPeriod,
        setDraggingPeriod,
        onClose,
        //mobile
    } = props;

    const [token] = useToken();

    const [presets, setPresets] = useState([]);

    const [dragPosition, setDragPosition] = useState(null);

    let periodPositionCounter = 10;
    let periodInsertionPlaced = false;
    let periodInsertionIndex = presets.length;

    const savePresets = (presets) => {
        TimeManager.time.saved.period.set(presets, token).then(() => {});
    };

    useEffect(() => {
        TimeManager.time.saved.period.get(token).then((data) => setPresets(data));
    }, [setPresets, token]);

    return open ? (
        <Box
            sx={{
                background: '#141517',
                width: '250px',
                paddingTop: '59px',
                zIndex: 300,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    height: '30px',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderTop: 'solid 1px #444',
                    borderRight: 'solid 1px #444',
                    userSelect: 'none',
                }}
            >
                <Typography
                    fontSize="1rem"
                    fontWeight="500"
                    ml="10px"
                >
                    Saved Periods
                </Typography>

                <Close
                    sx={{
                        mr: '10px',
                        cursor: 'pointer',
                    }}
                    onClick={onClose}
                />
            </Box>
            <OverlayScrollbarsComponent
                options={{
                    scrollbars: {
                        theme: 'os-theme-light'
                    }
                }}
                style={{
                    position: 'relative',
                    width: '100%',
                    height: 'calc(100% - 30px)',
                    borderTop: 'solid 1px #444',
                    borderRight: 'solid 1px #444',
                    paddingRight: '5px',
                }}
                onPointerLeave={draggingPeriod !== null ? () => setDragPosition(null) : undefined}
                onPointerMove={draggingPeriod !== null ? (e) => {
                    setDragPosition(e.clientY - e.currentTarget.offsetTop + e.currentTarget.children[0].scrollTop);
                } : undefined}
                onPointerUp={dragPosition !== null ? () => {
                    const presetInfo = {
                        name: draggingPeriod.name,
                        description: draggingPeriod.description,
                        location: draggingPeriod.location,
                        duration: draggingPeriod.duration || (draggingPeriod.end - draggingPeriod.start) / 1000 / 60,
                        labels: [...draggingPeriod.labels],
                    };

                    setPresets((oldPresets) => {
                        const transformedPresets = oldPresets.filter(period => period !== draggingPeriod);

                        const presets = [
                            ...transformedPresets.slice(0, periodInsertionIndex),
                            presetInfo,
                            ...transformedPresets.slice(periodInsertionIndex),
                        ];

                        savePresets(presets);

                        return presets;
                    });

                    setDragPosition(null);
                } : undefined}
                defer
            >
                {presets?.map?.((p, index) => {
                    const labelKey = p.labels?.[0] ? parseInt(p.labels?.[0]) : 0;
                    const label = labels.find((label) => label.key === labelKey);

                    const durationHours = Math.floor(p.duration / 60);
                    const durationMinutes = p.duration % 60;

                    const placeInsertion = dragPosition !== null && !periodInsertionPlaced && dragPosition <= periodPositionCounter + (p.duration / 2);

                    // I very well could use an if-statement here, but how often does someone get the opportunity to
                    // use the ||= operator? I choose whimsy.
                    periodInsertionPlaced ||= placeInsertion;
                    periodInsertionIndex = placeInsertion ? index : periodInsertionIndex;

                    periodPositionCounter += p.duration + 10;

                    return (
                        <Fragment key={p.name + index}>
                            {placeInsertion && (
                                <Divider
                                    sx={{
                                        width: 'calc(100% - 50px)',
                                        margin: '10px 25px',
                                        height: '2px',
                                    }}
                                />
                            )}
                            <Box
                                sx={{
                                    position: 'relative',
                                    height: `${p.duration - 2}px`,
                                    minHeight: `${p.duration - 2}px`,
                                    margin: '10px',
                                    background: label?.color || '#474747', //'#1a5038',
                                    borderRadius: '7px',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                    userSelect: 'none',
                                    '&:hover': {
                                        '.MuiButtonBase-root': {
                                            display: 'inline flex'
                                        },
                                        ...(p.duration < 50 && {
                                            height: 'auto',
                                            pb: '5px',
                                        }),
                                    },
                                    zIndex: 50,
                                }}
                                onClick={() => {
                                    //expand('Period', p)(e)
                                }}
                                onPointerDown={() => {
                                    setDraggingPeriod(p);
                                }}
                            >
                                <IconButton
                                    sx={{
                                        position: 'absolute',
                                        display: 'none',
                                        right: '5px',
                                        top: '5px',
                                    }}
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();

                                        setPresets((oldPresets) => {
                                            const presets = [...oldPresets].filter(period => period !== p);

                                            savePresets(presets);

                                            return presets;
                                        });
                                    }}
                                >
                                    <Delete fontSize="small" />
                                </IconButton>

                                <Typography
                                    m="5px 7px 0 9px"
                                    color="white"
                                    fontSize="10pt"
                                    fontWeight="700"
                                    fontFamily="'Inter', sans-serif"
                                    height="20px"
                                    p="0"
                                    sx={{
                                        textWrap: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }}
                                >
                                    {p.name}
                                </Typography>
                                <Typography
                                    m="0 7px 0 9px"
                                    color="white"
                                    fontSize="10pt"
                                    fontWeight="400"
                                    p="0"
                                >
                                    {[
                                        durationHours > 0 ? `${durationHours} hour${durationHours > 1 ? 's' : ''}` : [],
                                        durationMinutes > 0 ? `${durationMinutes} minute${durationMinutes > 1 ? 's' : ''}` : []
                                    ].flat().join(', ')}
                                </Typography>
                            </Box>
                        </Fragment>
                    );
                })}
                {dragPosition !== null && draggingPeriod !== null && (() => {
                    const p = draggingPeriod;

                    const labelKey = p.labels?.[0] ? parseInt(p.labels?.[0]) : 0;
                    const label = labels.find((label) => label.key === labelKey);

                    const duration = p.duration ? p.duration : (p.end - p.start) / 1000 / 60;
                    const durationHours = Math.floor(duration / 60);
                    const durationMinutes = duration % 60;

                    return (
                        <Box
                            key={p.name + p.key}
                            sx={{
                                position: 'absolute',
                                top: `${dragPosition}px`,
                                left: '10px',
                                right: '10px',
                                height: `${duration - 2}px`,
                                minHeight: `${duration - 2}px`,
                                background: label?.color || '#474747', //'#1a5038',
                                borderRadius: '7px',
                                cursor: 'pointer',
                                overflow: 'hidden',
                                userSelect: 'none',
                                '&:hover': duration < 50 && {
                                    height: 'auto',
                                    pb: '5px',
                                },
                                zIndex: 50,
                                filter: 'drop-shadow(0 0 0.75rem #111)',
                            }}
                        >
                            <Typography
                                m="5px 7px 0 9px"
                                color="white"
                                fontSize="10pt"
                                fontWeight="700"
                                fontFamily="'Inter', sans-serif"
                                height="20px"
                                p="0"
                                sx={{
                                    textWrap: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                                {p.name}
                            </Typography>
                            <Typography
                                m="0 7px 0 9px"
                                color="white"
                                fontSize="10pt"
                                fontWeight="400"
                                p="0"
                            >
                                {[
                                    durationHours > 0 ? `${durationHours} hour${durationHours > 1 ? 's' : ''}` : [],
                                    durationMinutes > 0 ? `${durationMinutes} minute${durationMinutes > 1 ? 's' : ''}` : []
                                ].flat().join(', ')}
                            </Typography>
                        </Box>
                    );
                })()}
                {draggingPeriod !== null && dragPosition !== null && !periodInsertionPlaced && (
                    <Divider
                        sx={{
                            width: 'calc(100% - 50px)',
                            margin: '10px 25px',
                            height: '2px',
                        }}
                    />
                )}
            </OverlayScrollbarsComponent>
        </Box>
    ) : <></>;
}